import React from "react";

const Darwinia = () => {
  return (
    <>
      <div className="align-items-center py-4">
      <h1 className="fw-bolder text-white">Darwinia</h1>
      <h6 className="fw-bolder text-gray">Under construction</h6>
      </div>
    </>
  );
};
export default Darwinia; 

